import * as actionTypes from "./actionTypes";
import API from "../../axios/api";
import axios from "axios";
import { isEqual } from 'lodash';
import filterObjectToQuery from '../../utils/filterObjectToQuery';

let CancelToken = axios.CancelToken;
let fetchLogs_cancel;
let fetchLogsById_cancel;

export const requestLogsStart = () => {
  return {
    type: actionTypes.REQUEST_LOGS_START,
  };
};

export const requestLogsByEmployeeIdStart = () => {
  return {
    type: actionTypes.REQUEST_LOGS_BY_EMPLOYEE_ID_START,
  }
}

export const requestLogByIdStart = () => {
  return {
    type: actionTypes.REQUEST_LOG_BY_ID_START,
  };
};

export const fetchLogsSuccess = (logs) => {
  return {
    type: actionTypes.FETCH_LOGS_SUCCESS,
    logs,
  };
};

export const setLogsFilter = (page, limit, search, order, orderBy, startDate, endDate, filteredUsers, filteredTypes, filteredOperationsName, filteredTables, filteredDocumentsIds) => {
  return {
    type: actionTypes.SET_LOGS_FILTER,
    logsFilter: {
      page,
      limit,
      search,
      order,
      orderBy,
      startDate,
      endDate,
      filteredUsers,
      filteredTypes,
      filteredOperationsName,
      filteredTables,
      filteredDocumentsIds
    },
  };
};

export const setLogsByElementIdFilter = (page, limit, search, order, orderBy, startDate, endDate, filteredUsers, filteredTypes, filteredOperationsName, filteredTables, filteredDocumentsIds) => {
  return {
    type: actionTypes.SET_LOGS_BY_ELEMENT_ID_FILTER,
    elementFilter: {
      page,
      limit,
      search,
      order,
      orderBy,
      startDate,
      endDate,
      filteredUsers,
      filteredTypes,
      filteredOperationsName,
      filteredTables,
      filteredDocumentsIds
    },
  };
};

export const setLogsUsersFilter = (users) => {
  return {
    type: actionTypes.SET_LOGS_USERS_FILTER,
    users,
  };
};

export const clearLogsFilter = (page, limit, search, order, orderBy) => {
  return dispatch => {
    dispatch(fetchLogs(page, limit, search, order, orderBy, null, null, [], [], [], [], []));
  }
}

export const clearLogsByElementIdFilter = (page, limit, search, order, orderBy, elementId) => {
  return dispatch => {
    dispatch(fetchLogsByElementId(page, limit, search, order, orderBy, null, null, [], [], [], [], elementId));
  }
}

export const triggerRemoveLogsStartDateFilter = (page, limit, search, order, orderBy, filteredEndDate, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, filteredDocumentsIds) => {
  return dispatch => {
    dispatch(fetchLogs(page, limit, search, order, orderBy, null, filteredEndDate, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, filteredDocumentsIds))
  }
};

export const triggerRemoveElementLogsStartDateFilter = (page, limit, search, order, orderBy, filteredEndDate, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, elementId) => {
  return dispatch => {
    dispatch(fetchLogsByElementId(page, limit, search, order, orderBy, null, filteredEndDate, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, elementId))
  }
};

export const triggerRemoveLogsEndDateFilter = (page, limit, search, order, orderBy, filteredStartDate, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, filteredDocumentsIds) => {
  return dispatch => {
    dispatch(fetchLogs(page, limit, search, order, orderBy, filteredStartDate, null, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, filteredDocumentsIds))
  }
};

export const triggerRemoveElementLogsEndDateFilter = (page, limit, search, order, orderBy, filteredStartDate, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, elementId) => {
  return dispatch => {
    dispatch(fetchLogsByElementId(page, limit, search, order, orderBy, filteredStartDate, null, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, elementId))
  }
};

export const triggerRemoveUsersFilter = (page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, filteredDocumentsIds, user) => {
  return dispatch => {
    let aux = [...selectedUsers];
    const newFilteredUsers = aux.filter((el) => el.value !== user.value);
    dispatch(fetchLogs(page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, newFilteredUsers, selectedTypes, selectedOperationsName, selectedTables, filteredDocumentsIds));
  }
};

export const triggerRemoveElementUsersFilter = (page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, user, elementId) => {
  return dispatch => {
    let aux = [...selectedUsers];
    const newFilteredUsers = aux.filter((el) => el.value !== user.value);
    dispatch(fetchLogsByElementId(page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, newFilteredUsers, selectedTypes, selectedOperationsName, selectedTables, elementId));
  }
};

export const triggerRemoveTypesFilter = (page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, filteredDocumentsIds, type) => {
  return dispatch => {
    let aux = [...selectedTypes];
    const newFilteredTypes = aux.filter((el) => el.value !== type.value);
    dispatch(fetchLogs(page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, selectedUsers, newFilteredTypes, selectedOperationsName, selectedTables, filteredDocumentsIds));
  }
};

export const triggerRemoveElementTypesFilter = (page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, type, elementId) => {
  return dispatch => {
    let aux = [...selectedTypes];
    const newFilteredTypes = aux.filter((el) => el.value !== type.value);
    dispatch(fetchLogsByElementId(page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, selectedUsers, newFilteredTypes, selectedOperationsName, selectedTables, elementId));
  }
};

export const triggerRemoveOperationsNameFilter = (page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, filteredDocumentsIds, operationName) => {
  return dispatch => {
    let aux = [...selectedOperationsName];
    const newFilteredOperationsName = aux.filter((el) => el.value !== operationName.value);
    dispatch(fetchLogs(page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, selectedUsers, selectedTypes, newFilteredOperationsName, selectedTables, filteredDocumentsIds));
  }
};

export const triggerRemoveElementOperationsNameFilter = (page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, operationName, elementId) => {
  return dispatch => {
    let aux = [...selectedOperationsName];
    const newFilteredOperationsName = aux.filter((el) => el.value !== operationName.value);
    dispatch(fetchLogsByElementId(page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, selectedUsers, selectedTypes, newFilteredOperationsName, selectedTables, elementId));
  }
};

export const triggerRemoveTablesFilter = (page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, filteredDocumentsIds, table) => {
  return dispatch => {
    let aux = [...selectedTables];
    const newFilteredTables = aux.filter((el) => el.value !== table.value);
    dispatch(fetchLogs(page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, selectedUsers, selectedTypes, selectedOperationsName, newFilteredTables, filteredDocumentsIds));
  }
};

export const triggerRemoveElementTablesFilter = (page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, table, elementId) => {
  return dispatch => {
    let aux = [...selectedTables];
    const newFilteredTables = aux.filter((el) => el.value !== table.value);
    dispatch(fetchLogsByElementId(page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, selectedUsers, selectedTypes, selectedOperationsName, newFilteredTables, elementId));
  }
};

export const triggerRemoveDocumentsIdsFilter = (page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, filteredDocumentsIds, docId) => {
  return dispatch => {
    let aux = [...filteredDocumentsIds];
    const newFilteredDocumentIds = aux.filter((el) => el !== docId);
    dispatch(fetchLogs(page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, newFilteredDocumentIds));
  }
};

export const fetchLogs = (
  page, limit, search, order, orderBy, startDate, endDate, filteredUsers, filteredTypes, filteredOperationsName, filteredTables, filteredDocumentsIds
) => {
  fetchLogs_cancel && fetchLogs_cancel();
  return (dispatch) => {
    dispatch(requestLogsStart());
    
    dispatch(setLogsFilter(page, limit, search, order, orderBy, startDate, endDate, filteredUsers, filteredTypes, filteredOperationsName, filteredTables, filteredDocumentsIds));
    let queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${
      !limit || limit < 25 ? limit : limit
    }&q=${search ? search : ''}&sort=${order === "desc" ? "-" : ""}${orderBy}`;
    queryParams += `${startDate ? `&start_date=${startDate.toISOString()}` : ''}`;
    queryParams += `${endDate  ? `&end_date=${endDate.toISOString()}` : ''}`;
    queryParams += `${filteredUsers && filteredUsers.length > 0 ? `&users=${filterObjectToQuery(filteredUsers)}` : ''}`;
    queryParams += `${filteredTypes && filteredTypes.length > 0 ? `&types=${filterObjectToQuery(filteredTypes)}` : ''}`;
    queryParams += `${filteredOperationsName && filteredOperationsName.length > 0 ? `&operationsName=${filterObjectToQuery(filteredOperationsName)}` : ''}`;
    queryParams += `${filteredTables && filteredTables.length > 0 ? `&tables=${filterObjectToQuery(filteredTables)}` : ''}`;
    queryParams += `${filteredDocumentsIds && filteredDocumentsIds.length > 0 ? `&docs_ids=${filteredDocumentsIds.join(',')}` : ''}`;

    API.get("/logs" + queryParams, {
      cancelToken: new CancelToken(function executor(c) {
        fetchLogs_cancel = c;
      })
    }).then((res) => {
      dispatch(fetchLogsSuccess(res.data));
    }).catch(err => {
      console.log(err)
    });
    
  };
};

export const fetchLogsById = (id) => {
  fetchLogsById_cancel && fetchLogsById_cancel();

  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(requestLogByIdStart());
      API.get("/logs/" + id, {
        cancelToken: new CancelToken(function executor(c) {
          fetchLogsById_cancel = c;
        }),
      })
        .then((res) => {
          dispatch(fetchLogsByIdSuccess(res.data));
          resolve("success");
        })
        .catch((err) => {
          /* dispatch(requestEmployeesFail(err)); */
          reject("error");
        });
    });
  };
};

export const fetchLogsByElementId = (page, limit, search, order, orderBy, startDate, endDate, filteredUsers, filteredTypes, filteredOperationsName, filteredTables, elementId) => {
  fetchLogs_cancel && fetchLogs_cancel();
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(setLogsByElementIdFilter(page, limit, search, order, orderBy, startDate, endDate, filteredUsers, filteredTypes, filteredOperationsName, filteredTables));
      dispatch(requestLogsByEmployeeIdStart());
      let queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${
        !limit || limit < 25 ? limit : limit
      }&q=${search ? search : ''}&sort=${order === "desc" ? "-" : ""}${orderBy}`;
      queryParams += `${startDate ? `&start_date=${startDate.toISOString()}` : ''}`;
      queryParams += `${endDate  ? `&end_date=${endDate.toISOString()}` : ''}`;
      queryParams += `${filteredUsers && filteredUsers.length > 0 ? `&users=${filterObjectToQuery(filteredUsers)}` : ''}`;
      queryParams += `${filteredTypes && filteredTypes.length > 0 ? `&types=${filterObjectToQuery(filteredTypes)}` : ''}`;
      queryParams += `${filteredOperationsName && filteredOperationsName.length > 0 ? `&operationsName=${filterObjectToQuery(filteredOperationsName)}` : ''}`;
      queryParams += `${filteredTables && filteredTables.length > 0 ? `&tables=${filterObjectToQuery(filteredTables)}` : ''}`;

      API.get(`/logs/element/${elementId}` + queryParams, {
        cancelToken: new CancelToken(function executor(c) {
          fetchLogs_cancel = c;
        }),
      }).then((res) => {
        dispatch(fetchLogsByEmployeeIdSuccess(res.data));
        resolve(res.data);
      }).catch(err => {
        reject('error');
      });
    });
  };
};

export const fetchLogsByIdSuccess = (log) => {
  return {
    type: actionTypes.FETCH_LOG_BY_ID_SUCCESS,
    log: log,
  };
};

export const fetchLogsByEmployeeIdSuccess = (log) => {
  return {
    type: actionTypes.FETCH_LOGS_BY_EMPLOYEE_ID_SUCCESS,
    log: log
  }
}

export const postOpenDocLogSucess = () => {
  return {
    type: actionTypes.POST_OPEN_DOC_LOG,
  }
}


export const postOpenDocLog = (body) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      API.post('/logs', body)
        .then(() => {
          dispatch(postOpenDocLogSucess())
          resolve('log created')
        })
        .catch((error) => {
          resolve('log failed', error.message)
        })
    })
  }
}